import React from "react";

/* =========================
   Text Input
========================= */

export function TextInput({
    label,
    value,
    onChange,
    placeholder = "",
    type = "text",
    className = "",
    ...props
}) {
    return (
        <div className="space-y-1">
            {label && (
                <label className="text-sm font-semibold text-slate-700">
                    {label}
                </label>
            )}

            <input
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={`
                    w-full
                    rounded-xl
                    border
                    border-slate-300
                    bg-white
                    px-4
                    py-3
                    shadow-sm
                    transition
                    focus:border-blue-600
                    focus:ring-2
                    focus:ring-blue-200
                    outline-none
                    ${className}
                `}
                {...props}
            />
        </div>
    );
}

/* =========================
   Number Input
========================= */

export function NumberInput(props) {
    return <TextInput type="number" {...props} />;
}

/* =========================
   Search Box
========================= */

export function SearchBox(props) {
    return (
        <TextInput
            placeholder="Search..."
            {...props}
        />
    );
}
export const DarkButton = (props) => (
    <Button
        color="bg-slate-900 hover:bg-black"
        {...props}
    />
);
/* =========================
   Select
========================= */

export function SelectBox({
    label,
    value,
    onChange,
    children,
    className = "",
}) {
    return (
        <div className="space-y-1">
            {label && (
                <label className="text-sm font-semibold text-slate-700">
                    {label}
                </label>
            )}

            <select
                value={value}
                onChange={onChange}
                className={`
                    w-full
                    rounded-xl
                    border
                    border-slate-300
                    bg-white
                    px-4
                    py-3
                    shadow-sm
                    focus:border-blue-600
                    focus:ring-2
                    focus:ring-blue-200
                    outline-none
                    ${className}
                `}
            >
                {children}
            </select>
        </div>
    );
}
/* =========================
   Text Area
========================= */

export function TextAreaInput({
    label,
    value,
    onChange,
    placeholder = "",
    rows = 5,
    className = "",
    ...props
}) {
    return (
        <div className="space-y-1">
            {label && (
                <label className="text-sm font-semibold text-slate-700">
                    {label}
                </label>
            )}

            <textarea
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                rows={rows}
                className={`
                    w-full
                    rounded-xl
                    border
                    border-slate-300
                    bg-white
                    px-4
                    py-3
                    shadow-sm
                    transition
                    focus:border-blue-600
                    focus:ring-2
                    focus:ring-blue-200
                    outline-none
                    resize-y
                    ${className}
                `}
                {...props}
            />
        </div>
    );
}
/* =========================
   Buttons
========================= */

function Button({
    children,
    color,
    onClick,
    type = "button",
    className = "",
    disabled = false,
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`
                px-5
                py-3
                rounded-xl
                font-semibold
                shadow
                transition
                text-white
                ${color}
                ${disabled ? "opacity-60 cursor-not-allowed" : ""}
                ${className}
            `}
        >
            {children}
        </button>
    );
}

export const PrimaryButton = (props) => (
    <Button
        color="bg-blue-600 hover:bg-blue-700"
        {...props}
    />
);

export const SuccessButton = (props) => (
    <Button
        color="bg-green-600 hover:bg-green-700"
        {...props}
    />
);

export const DangerButton = (props) => (
    <Button
        color="bg-red-600 hover:bg-red-700"
        {...props}
    />
);

export const SecondaryButton = (props) => (
    <Button
        color="bg-slate-600 hover:bg-slate-700"
        {...props}
    />
);

export const WarningButton = (props) => (
    <Button
        color="bg-orange-500 hover:bg-orange-600"
        {...props}
    />
);